<template>
  <div class="h-100">
    <div class="mid_scroll_content onlyEchange-page">
      <loader v-show="pageLoader"></loader>
      <section class="cap_exhange_cur h-100 border-0" v-if="
          tradingAccount.length > 0 && tradingAccount[0].subAccounts.length > 0
        ">
        <div class="mob-padnone row">
          <div class="col-12 my-4">
            <h3>Crypto Instant Exchange Tool</h3>
          </div>
          <div class="col-12 col-lg-4">
            <!--  v-if="step=='1'" -->
            <div class="boxLayout">
              <alert-notification v-if="notification_msg != ''" />
              <div class="section_title d-flex align-items-center justify-content-between mb-2">
                <h5>Convert from</h5>
                <p class="cur_result mb-0 medium"> Available Balance: <span class="green">{{ numberFormat(freeMargin) }} {{ send.currency }}</span>
                </p>
              </div>
              <div class="position-relative mb-2">
                <div class="six">
                  <div class="cursiveright cur_value pr-2">
                    <div class="curBal d-flex align-items-center">
                      <div class="cur_type mr-2" v-if="freeMargin != ''">
                        <input type="text" autocomplete="off" v-model="free_Margin" name="Margin" v-validate="{
                            required: true,
                            max_value: freeMargin,
                            regex: /^[.]|(?=.*[1-9])\d+(\.\d+)?$/,
                          }" />
                      </div>
                      <span class="firstName" v-else-if="send != ''">{{ send.currency.charAt(0)
                      }}</span>
                    </div>
                  </div>
                  <div class="cursiveLeft" @click.stop="
                      showSend = !showSend;
                      showReceive = false;
                    ">
                    <div class="dropdown cap_fund cur_ico">
                      <button class="no-border cap_btn dropdown-toggle" type="button" v-if="send.currency">
                        <img class="cp__ico" :src="
                            '../../../../static/website/images/crypto_logos/' +
                            send.currency.toLowerCase() +
                            '.png'
                          " alt="" @error="handleImgErr($event)" v-if="send != '' && checkImage(send.currency)" />
                        <span class="firstName" v-else-if="send != ''">{{ send.currency.charAt(0)
                        }}</span>{{ send.currency }}
                      </button>
                    </div>
                    <div class="dropdown-menu rounded" :class="showSend ? 'show' : ''">
                      <div class="cur_search showSend">
                        <input type="Search" placeholder="Search here" class="searchcrypto" v-model="searchSend" id="sendSearch" autocomplete="off" />
                      </div>
                      <div class="scrolling_text" v-if="tradingAccount.length > 0">
                        <table class="table table-stripped megaDropList">
                          <thead>
                            <tr>
                              <th>Assets</th>
                              <th>Holding Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="pointer" v-for="(value, key) in marginSearch(margin_list)" @click.prevent="
                                ChangeSendData(value, key);
                                searchSend = '';
                              " :class="
                                value.currency == send.currency ? 'active' : ''
                              " v-if="value.currency != 'TRXUSDT' && value.currency != 'TRXUSDC'">
                              <td>
                                <span class="d-flex align-items-center" v-if="value.currency">
                                  <img :src="
                                      '../../../../static/website/images/crypto_logos/' +
                                      value.currency.toLowerCase() +
                                      '.png'
                                    " @error="handleImgErr($event)" v-if="checkImage(value.currency)" />
                                  <span class="firstName" v-else>{{ value.currency.charAt(0)
                                  }}</span>
                                  <span class="muted semibold" v-if="$env_var.restricted_currencies.hasOwnProperty(value.currency)">
                                    <span class="fullName">{{ $env_var.restricted_currencies[value.currency].currency_name}}</span>
                                    <span>{{value.currency}}</span>
                                  </span>
                                  <span class="muted semibold" v-else>
                                    <span>{{value.currency}}</span>
                                    <span class="fullName">{{getCurrName(value.currency)}}</span>
                                  </span>
                                </span>
                              </td>
                              <!-- <td><span class="f-14 d-block">$114.32</span><span class="d-flex align-items-center green f-10" ><feather size="12px" class="mr-1" type="trending-up" ></feather> 0.72%</span ></td>-->
                              <td> {{ value.freemargin }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="valurPretage d-flex align-items-center justify-content-between flex-wrap">
                  <p v-if="submitted && errors.has('Margin')" class="mb-0 f-12 red">
                    {{ errors.first("Margin")
                    }}
                    <!-- You have insufficient {{send.currency}} available -->
                  </p>
                  <!-- <p v-else class="mb-0 f-12">Max:{{floatingValue((get_depth.MAX ? get_depth.MAX : 0),send.currency)}}</p> -->
                  <div class="d-flex align-items-center justify-content-between">
                    <a href="javascript:void(0);" :class="percentage == '25' ? 'themecolor' : ''" @click="setPercentage(25)">25%</a>
                    <a href="javascript:void(0);" :class="percentage == '50' ? 'themecolor' : ''" @click="setPercentage(50)">50%</a>
                    <a href="javascript:void(0);" :class="percentage == '75' ? 'themecolor' : ''" @click="setPercentage(75)">75%</a>
                    <a href="javascript:void(0);" :class="percentage == '100' ? 'themecolor' : ''" @click="setPercentage(100)">100%</a>
                  </div>
                </div>
              </div>
              <!-- <span class="text-danger text-right d-block w-100" v-if="submitted && errors.has('Margin')" >{{errors.first("Margin").includes("format is invalid") ? "Amount should be greater then zero" : errors.first("Margin")}}</span > -->
              <div class="secondMiddle">
                <div class="section_title mb-2">
                  <h5>To</h5>
                </div>
                <div class="six column">
                  <div class="cursiveright cur_value pr-2" v-if="get_depth && freeMargin">
                    <div class="d-flex align-items-center">
                      <div class="cur_type mr-2">
                        <span v-if="get_depth.A" contentEditable="false">{{ numberFormat(
                            floatingValue(get_depth.A * free_Margin, recive)
                          )
                        }}</span>
                        <span v-else contentEditable="false">0</span>
                      </div>
                      <p class="cur_result" v-if="recive == ''"> Please Select Currency </p>
                    </div>
                  </div>
                  <div class="text-right cur_value pr-2" v-else>
                    <div class="cur_type">
                      <span contentEditable="false" v-if="!errors.has('Margin') && get_depth">{{ numberFormat(get_depth.A * free_Margin) }}</span>
                      <p class="cur_result" v-if="recive == ''"> Please Select Currency </p>
                      <p class="cur_result" v-else> Please Select Another Currency </p>
                    </div>
                  </div>
                  <div class="cursiveLeft">
                    <div class="select_cur" @click.stop="
                        showReceive = !showReceive;
                        showSend = false;
                      ">
                      <div class="dropdown cap_fund cur_ico">
                        <button class="no-border cap_btn dropdown-toggle" type="button" v-if="recive">
                          <img class="cp__ico" :src="
                              '../../../../static/website/images/crypto_logos/' +
                              recive.toLowerCase() +
                              '.png'
                            " alt="" @error="handleImgErr($event)" v-if="recive != '' && checkImage(recive)" />
                          <span class="firstName" v-else-if="recive != ''">{{ recive.charAt(0)
                          }}</span>{{ recive }}
                        </button>
                      </div>
                    </div>
                    <div class="dropdown-menu rounded" :class="showReceive ? 'show' : ''">
                      <div class="cur_search showReceive">
                        <input type="Search" placeholder="Search here" class="searchcrypto" v-model="searchRecive" id="reciveSearch" autocomplete="off" />
                      </div>
                      <div class="scrolling_text">
                        <table class="table table-stripped megaDropList">
                          <thead>
                            <tr>
                              <th>Assets</th>
                              <th>Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="pointer" v-for="value in uniqueCurrencyList(
                                send,
                                searchRecive
                              )" @click.prevent="
                                recive = value;
                                searchRecive = '';
                              " :class="value == recive ? 'active' : ''" v-if="send.currency != value && value != 'TRXUSDT' && value != 'TRXUSDC'">
                              <td>
                                <span class="d-flex align-items-center icNmae" v-if="value">
                                  <img :src="
                                      '../../../../static/website/images/crypto_logos/' +
                                      value.toLowerCase() +
                                      '.png'
                                    " alt="" @error="handleImgErr($event)" v-if="checkImage(value)" />
                                  <span class="firstName" v-else>{{ value.charAt(0)
                                  }}</span>
                                  <span class="muted semibold" v-if="$env_var.restricted_currencies.hasOwnProperty(value)">
                                    <span class="fullName">{{$env_var.restricted_currencies[value].currency_name}}</span>
                                    <span>{{value}}</span>
                                  </span>
                                  <span class="muted semibold" v-else>
                                    <span>{{value}}</span>
                                    <span class="fullName">{{getCurrName(value)}}</span>
                                  </span>
                                  <!-- <span class="muted semibold"
                                    >{{ value
                                    }}<span class="fullName">{{
                                      getCurrName(value)
                                    }}</span></span
                                  > -->
                                </span>
                              </td>
                              <td>
                                <span class="f-14 d-block">{{ priceForSelectedCurrency(send.currency, value)
                                }}</span>
                                <!-- <span class="d-flex align-items-center green f-10" ><feather size="12px" class="mr-1" type="trending-up" ></feather> 0.72%</span > -->
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="cur_result d-flex justify-content-between medium themecolor my-2" v-if="get_depth.A && freeMargin">
                  <span class="price">Price</span> 1{{ send.currency }}≈{{ numberFormat(get_depth.A)
                  }}
                  {{ recive }}
                </p>
                <p class="cur_result d-flex justify-content-between medium themecolor my-2" v-if="get_depth.A && freeMargin">
                  <span class="price">Total</span>
                  <strong class="d-flex align-items-center secondary f-16" v-if="recive"> ≈{{ numberFormat(totalPrice)
                    }}
                    <!-- {{Total Price}} -->
                    <img class="ml-2" style="width: 28px" :src="
                        '../../../../static/website/images/crypto_logos/' +
                        recive.toLowerCase() +
                        '.png'
                      " @error="handleImgErr($event)" v-if="checkImage(recive)" />
                    <span class="ml-2" v-else>{{ recive }}</span>
                  </strong>
                </p>
                <p class="cur_result d-flex justify-content-between medium themecolor mb-2" v-if="get_depth.A && freeMargin">
                  <span class="price">Commission</span>
                  <strong class="d-flex align-items-center secondary f-16" v-if="tradePair"> ≈{{ numberFormat(getCommission) }}
                    <img class="ml-2" style="width: 28px" :src="
                        '../../../../static/website/images/crypto_logos/' +
                        spliting(tradePair, 1).toLowerCase() +
                        '.png'
                      " @error="handleImgErr($event)" v-if="checkImage(spliting(tradePair, 1))" />
                    <span class="ml-2" v-else>{{ spliting(tradePair, 1)
                    }}</span>
                  </strong>
                </p>
                <p class="cur_result d-flex justify-content-between medium themecolor my-2" v-if="get_depth.A && freeMargin">
                  <span class="price">You will receive</span>
                  <strong class="d-flex align-items-center secondary f-16" v-if="recive"> ≈{{ numberFormat(totalReceive)
                    }}
                    <!-- {{recived ammount}} -->
                    <img class="ml-2" style="width: 28px" :src="
                        '../../../../static/website/images/crypto_logos/' +
                        recive.toLowerCase() +
                        '.png'
                      " @error="handleImgErr($event)" v-if="checkImage(recive)" />
                    <span class="ml-2" v-else>{{ recive }}</span>
                  </strong>
                </p>
                <p class="d-flex align-items-center themecolor border-top pt-2">
                  <feather type="alert-circle" class="mr-3 flex-none red"></feather> Once the time expires, a new price will be generated
                </p>
                <p class="desclmr red" v-if="get_user.social_type == 1">
                  <strong>Disclaimer</strong>: Only funds that are available in main account can be used for smart trading
                </p>
              </div>
              <div class="formSubmitButton pt-1">
                <form class="d-flex align-items-center justify-content-center mt-1" @submit.prevent="submitFunc('1')" :class="[{ disabled: !parseFloat(get_depth.A) }]">
                  <input type="submit" class="mx-3 cap_btn blue large_btn" value="Confirm" />
                </form>
              </div>
            </div>
          </div>
          <!-- <div class="col-12 col-lg-4 confirmmation-history" v-if="step=='2'"><div class="confirminner"><div class="whiteBG"><p class="sm m-0">Pending <span>{{freeMargin - free_Margin}}</span>{{send.currency}}</p></div><div class="priceTable"><table class="table sellTable m-0"><tbody><tr><th>Price</th><td><span class="d-block line-height-one">{{numberFormat(expectedPrice)}}</span><a target="_blank" href="https://capitalwallet.com/faqs" class="expaneRate">Expected exchange rate</a></td></tr><tr><th>Qty</th><td>{{free_Margin}}{{send.currency}}</td></tr><tr><th>Estimated Commission</th><td>{{numberFormat(free_Margin * 0.005 * pairprice)}}{{commissionCurrency}}</td></tr><tr><th>Estimated Total</th><td v-if="commissionCurrency==send.currency">{{numberFormat( parseFloat(free_Margin * expectedPrice) - parseFloat(free_Margin * 0.005 * pairprice) * expectedPrice )}}{{recive}}</td><td v-else>{{numberFormat( expectedPrice * free_Margin - parseFloat(free_Margin * 0.005 * expectedPrice) )}}{{recive}}</td></tr></tbody></table></div><div class="form-group text-center"><input type="checkbox" class="cap_checkbox" id="checkbox-1" v-model="terms" name="terms" v-validate="'required'" /><label for="checkbox-1" class="checkbox-click-target"><span class="checkbox-box"></span>I agree with <a target="_blank" href="http://www.capitalwallet.com/terms"><strong>Term of Use</strong></a>,
                                    <a target="_blank" href="http://www.capitalwallet.com/privacy-policy"><strong>Privacy Policy</strong></a> and <a target="_blank" href="http://www.capitalwallet.com/aml"><strong>AML/KYC</strong></a><span class="text-danger d-block text-left" v-if="submitted && errors.has('terms')">Please check terms and condition </span></label></div><div class="buttonConfirm d-flex justify-content-between"><a class="uppercase cap_btn blue-b" href="#" @click.prevent=" step='1'; stopTimer(); "> Change </a><a class="uppercase cap_btn blue" :class="orderPlacedSuccess ? 'disabled' : ''" href="#" @click.prevent="submitFunc('2')">Confirm</a></div></div><p class="sm alert alert-warning mt-4" v-if="timer > 0">Order Time will expire in <span>{{timer}}</span> Seconds</p><p class="sm alert alert-warning mt-4" v-if="orderPlacedSuccess">Your placed Order is pending please wait</p></div><div class="col-12 col-lg-4 orderExpired d-flex align-items-center justify-content-center h-100" v-if="step=='3'"><div class="keepRefral"><div class="imgSteps"><img src="../../../../static/website/images/laptop-1.svg" alt="Icon" /><h3>your order has expired</h3><p>Please refresh the page. Dont't worry, we kept all of your filters and breakdowns in place</p></div><div class="buttonConfirm d-flex justify-content-center mt-4"><a class="uppercase cap_btn blue" href="#" @click.prevent="step='1'">Replace Order</a></div></div></div><div class="col-12 col-lg-4 orderExpired d-flex align-items-center justify-content-center h-100" v-if="step=='4'"><div class="keepRefral"><div class="imgSteps"><img src="../../../../static/website/images/success-icon.svg" alt="Icon" v-if="tempIdRecived.stat=='OK'" /><img src="../../../../static/website/images/laptop-1.svg" alt="Icon" v-else-if="tempIdRecived.stat=='NOK'" /><p v-html = "tempIdRecived.resp_msg"></p></div><div class="buttonConfirm d-flex justify-content-center mt-4"><router-link class="uppercase cap_btn blue" to="/transaction-history">view order</router-link></div></div></div> -->
          <div class="col-12 col-lg-8">
            <div class="tether d-flex align-items-center justify-content-between flex-wrap">
              <div class="d-flex align-items-center mobSpace">
                <span class="flex-shrink-0" v-if="tradePair">
                  <img width="60" :src="
                      '../../../../static/website/images/crypto_logos/' +
                      spliting(tradePair, 0).toLowerCase() +
                      '.png'
                    " @error="handleImgErr($event)" :alt="spliting(tradePair, 0)" v-if="checkImage(spliting(tradePair, 0).toLowerCase())" />
                  <span class="firstName" v-else>{{ spliting(tradePair, 0).charAt(0)
                  }}</span>
                </span>
                <div class="flex-grow-1 ml-3">
                  <h3 class="mb-2 semibold">
                    {{ instruments[tradePair]
                        ? instruments[tradePair].other.Description
                        : getCurrName(spliting(tradePair, 0))
                    }} / {{ getCurrName(spliting(tradePair, 1)) }}
                  </h3>
                  <p class="f-18 mb-0">{{ tradePair || "-" }}</p>
                  <!-- <span>printIsin(instruments[tradePair])</span> -->
                </div>
              </div>
              <a :href="$env_var.webTrader + token" target="_blank" class="cap_btn secondaryBG d-flex align-items-center">
                <feather size="16px" class="mr-1" type="trending-up"></feather> Advanced Trading
              </a>
              <!-- <a :href="'https://devpricefeed.capitalwallet.com/?token='+token" target="_blank" class="cap_btn secondaryBG d-flex align-items-center"> -->
            </div>
            <div class="curValue mt-4" v-if="instruments[tradePair]">
              <div class="d-flex align-items-center mb-3">
                <h2>
                  <span :class="[
                      {
                        green: instruments[tradePair].sell_increase_staus === 1,
                        red: instruments[tradePair].sell_increase_staus === 0,
                      },
                    ]" v-if="tradePair == send.currency + '-' + recive">{{ numberFormat(formatfloat(instruments[tradePair].A))
                    }}</span>
                  <span :class="[
                      {
                        green: instruments[tradePair].buy_increase_staus === 1,
                        red: instruments[tradePair].buy_increase_staus === 0,
                      },
                    ]" v-if="tradePair == recive + '-' + send.currency">{{ formatfloat(instruments[tradePair].A) }}</span>
                  <sub class="f-16 ml-2">{{ spliting(tradePair, 1) }}</sub>
                </h2>
                <span class="ml-4 d-flex align-items-center" :class="[
                    { green: formatfloat(instruments[tradePair].CB) > 0 },
                    { red: formatfloat(instruments[tradePair].CB) < 0 },
                  ]" v-if="instruments[tradePair] && instruments[tradePair].CB">
                  <feather size="16px" class="mr-1" type="trending-up" v-if="formatfloat(instruments[tradePair].CB) > 0" />
                  <feather size="16px" class="mr-1" type="trending-down" v-if="formatfloat(instruments[tradePair].CB) 
										< 0" />
                  {{ numberFormat(
                      formatfloat(parseFloat(instruments[tradePair].CB))
                    )
                  }}%
                </span>
              </div>
              <div class="d-flex align-items-center">
                <p class="mb-0 themecolor medium f-16"> Low: {{ numberFormat(formatfloat(instruments[tradePair].LOW)) }}
                </p>
                <!-- <div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 40%;"></div></div> -->
                <p class="mb-0 themecolor medium f-16 ml-2"> High: {{ numberFormat(formatfloat(instruments[tradePair].HIGH)) }}
                </p>
                <p class="mb-0 supBtn">24h</p>
              </div>
            </div>
            <!--  v-if="instruments[tradePair]" -->
            <!--  <marketChart
              v-if="tradePair != ''"
              :mn="
                instruments[tradePair]
                  ? instruments[tradePair].other.mn
                  : tradePair
              "
              :pairName="tradePair"
            /> -->
            <!-- <p class="text-right mt-3">APR 7, 13:22 UTC</p> -->
          </div>
          <div class="col-12">
            <div class="recentTransactions">
              <div class="headerElement my-4 d-flex align-items-center justify-content-between flex-wrap">
                <h3 class="mb-0 mobSpace">Recent Exchange Transactions</h3>
                <div class="d-flex align-items-center flex-wrap between">
                  <a v-if="orderList.records.length" href="javascript:void(0)" @click="() => downloadTransactions()" class="borderBtn mr-3">Download Transactions</a>
                  <div class="form-group position-relative includeIco searchTable mb-0">
                    <input type="text" placeholder="Find Transactions.." name="legal_name" class="form-control small" />
                    <span class="searchIco">
                      <feather type="search"></feather>
                    </span>
                  </div>
                </div>
              </div>
              <div class="border position-relative border-radius-15">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Converted from</th>
                        <th>Quantity</th>
                        <th>Converted to</th>
                        <th>Quantity</th>
                        <th>Amount(USD)</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody v-if="orderList.records.length > 0 && !pageLoader">
                      <tr v-for="(item, index) in orderList.records" v-if="
                          index >= (page - 1) * pageLimit &&
                          index < page * pageLimit
                        ">
                        <td>{{ formatDate(item.sortDate) }}</td>
                        <!-- <td>{{item}}</td> -->
                        <td>
                          <span v-if="item.OrderSide == 1">
                            <!-- {{spliting(item.Symbol, 1)}} -->
                            <p v-if="$env_var.restricted_currencies.hasOwnProperty(spliting(item.Symbol, 1))">{{ $env_var.restricted_currencies[spliting(item.Symbol, 1)].currency_name }}</p>
                            <p v-else>{{spliting(item.Symbol, 1)}}</p>
                          </span>
                          <span v-if="item.OrderSide == 0">
                            <!-- {{spliting(item.Symbol, 0)}} -->
                            <p v-if="$env_var.restricted_currencies.hasOwnProperty(spliting(item.Symbol, 0))">{{ $env_var.restricted_currencies[spliting(item.Symbol, 0)].currency_name }}</p>
                            <p v-else>{{spliting(item.Symbol, 0)}}</p>
                          </span>
                        </td>
                        <td v-if="item.Status == 'CANCELED'">
                          <span>{{ floatingValue(
                              item.QuantityRemaining,
                              spliting(item.Symbol, 0)
                            )
                          }}</span>
                          <!-- <span v-if="item.OrderSide == 1">{{floatingValue((item.QuantityFilled * item.PriceFilled ),spliting(item.Symbol,1))}}</span><span v-if="item.OrderSide == 0">{{floatingValue(item.QuantityFilled,spliting(item.Symbol,0))}}</span> -->
                        </td>
                        <td v-else-if="item.Status == 'CREATED'">
                          <span v-if="item.OrderSide == 1">{{ floatingValue(
                              item.QuantityRemaining *
                                (item.Price || item.StopPrice),
                              spliting(item.Symbol, 0)
                            )
                          }}</span>
                          <span v-if="item.OrderSide == 0">{{ floatingValue(
                              item.QuantityRemaining,
                              spliting(item.Symbol, 0)
                            )
                          }}</span>
                          <!-- <span v-if="item.OrderSide == 1">{{floatingValue((item.QuantityFilled * item.PriceFilled ),spliting(item.Symbol,1))}}</span><span v-if="item.OrderSide == 0">{{floatingValue(item.QuantityFilled,spliting(item.Symbol,0))}}</span> -->
                        </td>
                        <td v-else>
                          <span v-if="item.OrderSide == 1">{{ floatingValue(
                              item.QuantityFilled * item.PriceFilled -
                                item.Commission,
                              spliting(item.Symbol, 1)
                            )
                          }}</span>
                          <span v-if="item.OrderSide == 0">{{ floatingValue(
                              item.QuantityFilled,
                              spliting(item.Symbol, 0)
                            )
                          }}</span>
                        </td>
                        <td>
                          <span v-if="item.OrderSide == 1">
                            <!-- {{spliting(item.Symbol, 0)}} -->
                            <p v-if="$env_var.restricted_currencies.hasOwnProperty(spliting(item.Symbol, 0))">{{ $env_var.restricted_currencies[spliting(item.Symbol, 0)].currency_name }}</p>
                            <p v-else>{{spliting(item.Symbol, 0)}}</p>
                          </span>
                          <span v-if="item.OrderSide == 0">
                            <!-- {{spliting(item.Symbol, 1)}} -->
                            <p v-if="$env_var.restricted_currencies.hasOwnProperty(spliting(item.Symbol, 1))">{{ $env_var.restricted_currencies[spliting(item.Symbol, 1)].currency_name }}</p>
                            <p v-else>{{spliting(item.Symbol, 1)}}</p>
                          </span>
                        </td>
                        <td v-if="item.Status == 'CANCELED'">
                          <span>0</span>
                        </td>
                        <td v-else>
                          <span v-if="item.OrderSide == 1">{{ floatingValue(
                              item.QuantityFilled,
                              spliting(item.Symbol, 0)
                            )
                          }}</span>
                          <span v-if="item.OrderSide == 0">{{ floatingValue(
                              item.QuantityFilled * item.PriceFilled -
                                item.Commission,
                              spliting(item.Symbol, 1)
                            )
                          }}</span>
                        </td>
                        <td>-</td>
                        <td :class="statusTypeList[item.Status].class">
                          {{ statusTypeList[item.Status].text }}
                        </td>
                      </tr>
                    </tbody>
                    <table-loader :pageloader_value="pageLoader" :type="'table'" :colspan="'7'" :listLength="orderList.records.length" v-else></table-loader>
                  </table>
                </div>
                <pagination :totalRecords="orderList.records.length" :limit="pageLimit" :pageNo="page" v-if="orderList.records.length > 0 && !pageLoader"></pagination>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="cap_main_chart border-0 h-100" v-else>
        <div class="row align-items-center mobStart h-100">
          <div class="col-12">
            <div class="notTrade-account w-500 mx-auto text-center">
              <alert-notification v-if="notification_msg != ''" />
              <div class="imgTrade">
                <img src="../../../../static/website/images/4389.svg" alt="Icon" />
              </div>
              <p>No trading Account Available</p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Successfully Converted -->
    <!-- v-if="[2,3,4].includes(parseInt(step))" -->
    <div class="modal fade" :class="[{ show: [2, 3, 4].includes(parseInt(step)) }]" id="exampleModalCenter" style="display: block" v-show="[2, 3, 4].includes(parseInt(step))">
      <div class="modal-dialog w-100 modal-dialog-centered" role="document">
        <div class="modal-content">
          <button type="button" class="close text-right pr-2" @click="closeStep()">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body text-center" v-if="parseInt(step) == 2">
            <div class="whiteBG">
              <h6 class="sm m-0 alert alert-success w-100"> Spending Amount <span>{{ free_Margin }}</span>{{ send.currency }}
              </h6>
            </div>
            <div class="priceTable">
              <table class="table text-left sellTable m-0">
                <tbody>
                  <tr>
                    <th>Price</th>
                    <td>
                      <span class="d-block line-height-one">1{{ send.currency }}≈{{ numberFormat(currentPrice) }}
                        {{ recive }}</span>
                      <a target="_blank" href="https://capitalwallet.com/faqs" class="expaneRate">Expected exchange rate</a>
                    </td>
                  </tr>
                  <tr>
                    <th>Qty</th>
                    <td>
                      <span class="d-flex align-items-center justify-content-end">≈{{ numberFormat(currentPrice * free_Margin) }}
                        <img class="ml-2" style="width: 28px" :src="
                            '../../../../static/website/images/crypto_logos/' +
                            recive.toLowerCase() +
                            '.png'
                          " @error="handleImgErr($event)" v-if="checkImage(recive)" />
                        <span class="ml-2" v-else>{{ recive }}</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>Estimated Commission</th>
                    <td>
                      <span class="d-flex align-items-center justify-content-end">≈{{ numberFormat(totalCommission) }}
                        <img class="ml-2" style="width: 28px" :src="
                            '../../../../static/website/images/crypto_logos/' +
                            spliting(tradePair, 1).toLowerCase() +
                            '.png'
                          " @error="handleImgErr($event)" v-if="checkImage(spliting(tradePair, 1))" />
                        <span class="ml-2" v-else>{{ spliting(tradePair, 1)
                        }}</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>Estimated Total</th>
                    <td>
                      <span class="d-flex align-items-center justify-content-end">≈{{ numberFormat(purchasedTotal) }}
                        <img class="ml-2" style="width: 28px" :src="
                            '../../../../static/website/images/crypto_logos/' +
                            recive.toLowerCase() +
                            '.png'
                          " @error="handleImgErr($event)" v-if="checkImage(recive)" />
                        <span class="ml-2" v-else>{{ recive }}</span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-group text-center">
              <input type="checkbox" class="cap_checkbox" id="checkbox-1" v-model="terms" name="terms" v-validate="'required'" />
              <label for="checkbox-1" class="checkbox-click-target">
                <span class="checkbox-box"></span>I agree with <a target="_blank" href="http://www.capitalwallet.com/terms">
                  <strong>Term of Use</strong>
                </a>, <a target="_blank" href="http://www.capitalwallet.com/privacy-policy">
                  <strong>Privacy Policy</strong>
                </a> and <a target="_blank" href="http://www.capitalwallet.com/aml">
                  <strong>AML/KYC</strong>
                </a>
                <span class="text-danger d-block text-left" v-if="submitted && errors.has('terms')">Please check terms and condition </span>
              </label>
            </div>
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <a href="javascript:void(0)" class="cap_btn large_btn border-btn mb-2" @click="
                  step = '1';
                  stopTimer();
                "> Change</a>
              <a href="javascript:void(0)" class="cap_btn large_btn mb-2" :class="orderPlacedSuccess ? 'disabled' : ''" @click="submitFunc('2')">Place Order</a>
            </div>
            <p class="sm alert alert-warning mt-4" v-if="timer > 0"> Order Time will expire in <span>{{ timer }}</span> Seconds </p>
            <p class="sm alert alert-warning mt-4" v-if="orderPlacedSuccess"> Your placed Order is pending please wait </p>
          </div>
          <div class="modal-body expired text-center" v-if="parseInt(step) == 3">
            <img src="../../../../static/website/images/laptop-1.svg" alt="API" title="API" />
            <h5 class="mb-3">your order has expired</h5>
            <p> Please refresh the page. Dont't worry, we kept all of your filters and breakdowns in place </p>
            <div class="mt-4 mb-2 d-flex align-items-center justify-content-center">
              <a href="javascript:void(0)" class="cap_btn large_btn border-btn" @click.prevent="step = '1'">Replace Order</a>
            </div>
          </div>
          <div class="modal-body smallIcon text-center" v-if="parseInt(step) == 4">
            <img src="../../../../static/website/images/success-icon.svg" alt="Icon" v-if="tempIdRecived.stat == 'OK'" />
            <img src="../../../../static/website/images/laptop-1.svg" alt="Icon" v-else-if="tempIdRecived.stat == 'NOK'" />
            <h6 class="medium d-block" v-html="tempIdRecived.resp_msg"></h6>
            <h6 class="my-4 medium btc d-flex align-items-center justify-content-between flex-row-reverse">
              {{ numberFormat(orderPending.free_Margin) }}
              <strong class="d-flex align-items-center justify-content-center">{{ orderPending.from }}</strong>
            </h6>
            <ul class="s-convert border-top py-3 mb-4 border-bottom">
              <li class="d-flex align-items-center justify-content-between">
                <p class="themecolor mb-0">Received</p>
                <span class="d-flex align-items-center">
                  <p class="themecolor mb-0">
                    {{ numberFormat(orderPending.estimatedPrice) }}
                    {{ orderPending.to }}
                  </p>
                  <a href="javascript:void(0)" class="link ml-3">
                    <img class="mb-0" src="../../../../static/website/images/walletAlt.svg" alt="Icon" title="Wallet" />
                  </a>
                </span>
              </li>
              <li class="d-flex align-items-center justify-content-between">
                <p class="themecolor mb-0">Price</p>
                <p class="themecolor mb-0"> 1 {{ orderPending.from }} = {{ numberFormat(orderPending.price) }} {{ orderPending.to }}
                </p>
              </li>
            </ul>
            <div class="d-flex align-items-center justify-content-between">
              <a href="javascript:void(0)" class="cap_btn large_btn border-btn" @click="step = '1'">Close</a>
              <router-link to="/transaction-history" class="cap_btn large_btn">Order Details</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Const
  } from "@/plugins/vue-provider-cache/const.mod";
  import tradingMixins from "@/plugins/trading";
  // import marketChart from "./market-chart";
  import math from "../../../../static/website/js/math.js";
  // import commonAllMixins from '@/plugins/commonAll';
  import * as types from "@/types";
  export default {
    name: "smart-trading",
    mixins: [tradingMixins],
    data() {
      return {
        pageLoader: false,
        page: "1",
        pageLimit: "10",
        taskTab: "Price",
        charTab: "date",
        combinedData: "",
        notification_msg: "",
        notification_type: "",
        send: "",
        recive: "USD",
        margin_list: {},
        freeMargin: "",
        free_Margin: "",
        step: "1",
        searchSend: "",
        searchRecive: "",
        showSend: false,
        showReceive: false,
        percentage: 25,
        submitted: true,
        terms: false,
        timer: 0,
        downloadTimer: "",
        currentPrice: 0,
        purchasedQnt: 0,
        totalCommission: 0,
        purchasedTotal: 0,
        orderPending: {},
        tempIdRecived: {},
        orderPlacedSuccess: false,
        tradePair: "",
        errImage: [],
        statusTypeList: {
          CREATED: {
            text: "Pending",
            class: "yellow"
          },
          FILLED: {
            text: "Approved",
            class: "green"
          },
          CANCELED: {
            text: "Rejected",
            class: "red"
          },
        },
        notCryptoCurrency: ["EURO", "USD", "AUD", "GBP", "JPY"],
      };
    },
    components: {
      //marketChart,
    },
    computed: {
      token() {
        try {
          return this.$store.getters[types.GET_TOKEN];
        } catch (e) {
          return "";
        }
      },
      instruments() {
        try {
          this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
          return this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].iCache.asKeysValueArrayAll();
        } catch (ex) {
          return {};
        }
      },
      get_depth() {
        try {
          this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
          return this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].iCache.asKeysValueArray(this);
        } catch (ex) {
          return {};
        }
      },
      get_buy_sell() {
        try {
          this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
          return this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].iCache.getCryptoCurrency(this);
          // }
        } catch (ex) {
          // console.log('OO-one [ex]', ex)
          return {};
        }
      },
      totalPrice() {
        try {
          let total = this.free_Margin * this.get_depth.A;
          return this.floatingValue(total, this.recive);
        } catch (e) {
          return 0;
          console.log("totalPrice", e);
        }
      },
      getCommission() {
        try {
          let side = 0;
          if (this.recive + "-" + this.send.currency == this.tradePair) {
            side = 1;
          }
          let total = this.free_Margin * (side || this.get_depth.A) * 0.005;
          if (this.notCryptoCurrency.includes(this.spliting(this.tradePair, 1))) {
            return parseFloat(total).toFixed(2);
          } else {
            return this.formatfloat(parseFloat(parseFloat(total).toFixed(8)));
          }
        } catch (e) {
          console.log("getCommission", e);
          return 0;
        }
      },
      totalReceive() {
        try {
          let side = 0;
          if (this.recive + "-" + this.send.currency == this.tradePair) {
            side = 1;
          }
          let total = this.free_Margin * this.get_depth.A - this.getCommission * (side ? this.get_depth.A : 1);
          if (this.notCryptoCurrency.includes(this.recive)) {
            return parseFloat(total).toFixed(2);
          } else {
            return this.formatfloat(parseFloat(parseFloat(total).toFixed(8)));
          }
        } catch (e) {
          console.log("totalReceive", e);
          return 0;
        }
      },
    },
    watch: {
      tradingAccount(value) {
        this.getCurrency(value);
      },
      /*tradingAccount(value) {
              if (!parseInt(this.accountSelected)) {
                  this.getCurrency(value, 1);
              }
          },  
          socialAccount(value) {
              if (parseInt(this.accountSelected) == 1) {
                  this.getCurrency(value, 1);
              }
          },*/
      send(value) {
        let amount = this.formatfloat(value.amount);
        // console.log(value,amount)
        this.freeMargin = amount;
        this.free_Margin = this.floatingValue(amount * (25 / 100), value.currency);
        this.changeReciveCurr();
      },
      margin_list(value) {
        let changedSend = true;
        if (Object.keys(this.send).length > 0) {
          for (let key in value) {
            if (key == this.send.act_account_id && value[key].amount != 0) {
              this.send = value[key];
              changedSend = false;
            }
          }
        }
        if (changedSend) {
          if (this.$route.params.sendCurrency) {
            for (let key in value) {
              if (value[key].currency.toLowerCase().includes(this.$route.params.sendCurrency.toLowerCase())) {
                this.send = value[key];
                this.send.act_account_id = key;
              }
            }
          } else {
            let [firstKey] = Object.keys(value);
            this.send = value[firstKey];
            this.send.act_account_id = firstKey;
          }
        }
      },
      recive(value) {
        this.subscribe();
      },
      combinedCurrency(value) {
        if (this.tradePair == "" && this.send.currency) {
          this.changeReciveCurr();
        }
      },
    },
    methods: {
      closeStep() {
        if (parseInt(this.step) == 2) {
          this.stopTimer();
        }
        this.step = "1";
      },
      /*printIsin(i){
              console.log(i)
          },*/
      marginSearch(margin_list) {
        if (this.searchSend == "") {
          return margin_list;
        } else {
          let data = {};
          for (let key in margin_list) {
            if (margin_list[key].currency.toLowerCase().includes(this.searchSend.toLowerCase())) {
              data[key] = margin_list[key];
            }
          }
          return data;
        }
      },
      formatfloat(num) {
        if (num) {
          num = parseFloat(num);
          try {
            return math.format(num, {
              notation: "fixed"
            }) || "";
          } catch (e) {
            try {
              return num.toFixed(8);
            } catch (e) {
              return "";
            }
          }
        } else {
          return 0;
        }
      },
      ChangeSendData(data, act_account_id) {
        this.send = data;
        this.send.act_account_id = act_account_id;
      },
      checkImage(val) {
        return this.errImage.includes(val) ? false : true;
      },
      weightedMean(arrValues, arrWeights) {
        var result = arrValues.map(function(value, i) {
          var weight = arrWeights[i];
          var sum = value * weight;
          return [sum, weight];
        }).reduce(function(p, c) {
            return [p[0] + c[0], p[1] + c[1]];
          },
          [0, 0]);
        return result[0] / result[1];
      },
      handleImgErr(val) {
        var fullSrc = val.target.src.split(".");
        var src = fullSrc[fullSrc.length - 2].split("/");
        var img = src[src.length - 1];
        if (!this.errImage.includes(img)) {
          this.errImage.push(img);
        }
      },
      subscribe() {
        let dataArr2 = this.send.currency + "-" + this.recive;
        let dataArr1 = this.recive + "-" + this.send.currency;
        if (this.combinedCurrency.includes(dataArr1)) {
          this.tradePair = dataArr1;
          try {
            this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders["S_PF_PF"].subscribe([dataArr1]);
          } catch (e) {}
          this.tradePair = dataArr1;
        } else if (this.combinedCurrency.includes(dataArr2)) {
          this.tradePair = dataArr2;
          try {
            this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders["S_PF_PF"].subscribe([dataArr2]);
          } catch (e) {}
          this.tradePair = dataArr2;
        } else if (this.combinedCurrency.length > 0) {
          console.log(dataArr2, dataArr1, this.combinedCurrency);
          this.tradePair = "";
          this.displayError("no key found", "error");
        }
      },
      changeReciveCurr() {
        if (this.uniqueCurrencyList(this.send).length > 0 || this.send.currency == this.recive) {
          if (this.$route.params.receiveCurrency) {
            this.recive = this.$route.params.receiveCurrency;
            delete this.$route.params.receiveCurrency;
          } else {
            if (!this.uniqueCurrencyList(this.send).includes(this.recive) || this.send.currency == this.recive) {
              if (this.send.currency == this.uniqueCurrencyList(this.send)[0]) {
                this.recive = this.uniqueCurrencyList(this.send)[1];
              } else {
                this.recive = this.uniqueCurrencyList(this.send)[0];
              }
            } else {
              this.subscribe();
            }
          }
        } else {
          this.subscribe();
        }
      },
      uniqueCurrencyList(val, search) {
        if (val != "" && val.currency && this.cryptoList.length > 0) {
          try {
            var unique = [];
            for (var key in this.cryptoList) {
              // if (parseInt(this.combinedCurrency[key].Spread) == 1) {
              let data = this.cryptoList[key].isinid;
              if (data.includes("-") && data.split("-").includes(val.currency)) {
                unique = unique.concat(data.split("-"));
              }
              // }
            }
            unique = [...new Set(unique)].sort().filter((val) => {
              return (!["XMR", "ZEC", "DASH", "XVG", "ZEN", "XRP", "BEAM"].includes(val.toUpperCase()) && val.currency != val);
            });
            if (search && search != "") {
              return unique.filter((val) => val.toLowerCase().includes(this.searchRecive.toLowerCase()));
            }
            return unique;
          } catch (e) {
            console.log(e);
            return [];
          }
        } else {
          return [];
        }
      },
      currencyListFunc(type) {
        if (type == "send") {
          if (this.searchSend == "") {
            return this.tradingAccount[0].subAccounts;
          } else {
            return this.tradingAccount[0].subAccounts.filter((val) => val.currency.toLowerCase().includes(this.searchSend.toLowerCase()));
          }
        } else if (type == "recive") {
          if (this.searchRecive == "") {
            return this.uniqueCurrency;
          } else {
            return this.uniqueCurrency.filter((val) => val.toLowerCase().includes(this.searchRecive.toLowerCase()));
          }
        }
      },
      submitFunc(step) {
        if (!this.get_depth.A) {
          return;
        }
        const _that = this;
        _that.submitted = true;
        let side = 1;
        if (this.recive + "-" + this.send.currency == this.tradePair) {
          side = 1;
        } else if (this.send.currency + "-" + this.recive == this.tradePair) {
          side = 0;
        }
        if (_that.get_depth && step == "1") {
          _that.$validator.validate().then((valid) => {
            if (valid && parseFloat(_that.freeMargin) >= parseFloat(_that.free_Margin)) {
              _that.currentPrice = _that.floatingValue(_that.get_depth.A, _that.recive);
              _that.totalCommission = _that.getCommission;
              _that.purchasedTotal = _that.totalReceive;
              _that.step = "2";
              _that.startTimer();
            } else {
              _that.displayError("You can buy maximum sell upto" + _that.freeMargin + " " + _that.send.currency, "error");
            }
          });
        } else if (step == "2") {
          _that.$validator.validate().then((valid) => {
            if (valid) {
              let qty = _that.free_Margin;
              const tempOrderId = new Date().getTime();
              // if (side == 1) {
              //   qty = _that.totalReceive;
              // }
              let orderJson = {
                symbol: _that.tradePair,
                quantity: qty,
                side: side,
                stop: 0,
                limit: 0,
                trail: 0,
                lifetime: "GTC",
                commentary: "Instant Fill",
                tempOrderId: tempOrderId,
                account_id: _that.tradingAccount[0].account_id,
                localParams: _that,
              };
              _that.orderPending = Object.assign({}, orderJson);
              _that.orderPending.free_Margin = _that.free_Margin;
              _that.orderPending.from = _that.send.currency;
              _that.orderPending.to = _that.recive;
              _that.orderPending.price = _that.currentPrice;
              _that.orderPending.commision = _that.totalCommission;
              _that.orderPending.estimatedPrice = _that.purchasedTotal;
              _that.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders["S_PF_PF"].placeOrder(orderJson);
              _that.stopTimer();
            }
          });
        }
      },
      floatingValue(total, currency) {
        try {
          if (this.notCryptoCurrency.includes(currency)) {
            return parseFloat(total).toFixed(2);
          } else {
            return this.formatfloat(parseFloat(parseFloat(total).toFixed(8)));
          }
          // return this.formatPrice(total,!this.notCryptoCurrency.includes(currency))
        } catch (e) {
          return 0;
        }
      },
      callMargin() {
        let _that = this;
        setTimeout(function() {
          _that._runGetMarginInfo({
            globalParams: {
              account_id: _that.tradingAccount[0].account_id
            },
            localParams: {
              parameter: _that,
              page: "exchange"
            },
          });
        }, 3000);
      },
      successWs() {
        this.orderPlacedSuccess = true;
        let _that = this;
        let Timer = setInterval(function() {
          let orderMessage = localStorage.getItem("orderMessage");
          if (orderMessage) {
            let data = JSON.parse(orderMessage);
            if (data.tempOrderId == _that.orderPending.tempOrderId) {
              _that.orderPlacedSuccess = false;
              // _that.displayError(data.resp_msg, "success");
              _that.tempIdRecived = data;
              _that.step = "4";
              localStorage.removeItem("orderMessage");
              // _that.callMargin()
              clearInterval(Timer);
            }
          }
        }, 500);
      },
      startTimer() {
        let timer = 15;
        this.timer = 15;
        var _that = this;
        this.downloadTimer = setInterval(() => {
          if (timer <= 0) {
            clearInterval(_that.downloadTimer);
            _that.step = "3";
          }
          timer -= 1;
          _that.timer = timer;
        }, 1000);
      },
      stopTimer() {
        clearInterval(this.downloadTimer);
        this.timer = 0;
      },
      failedWs() {
        this.displayError("faild to Place order", "error");
        // console.log('failed')
      },
      displayError(getMessage, type) {
        /*this.$notify({
    				group: 'foo',
    				type: (type && type == null)?'error':type,
    				text: getMessage,
    				duration: 2000,
    				closeOnClick: true,
    				position: "center bottom"
    			});*/
        var _that = this;
        try {
          _that.notification_msg = getMessage;
          _that.notification_type = type;
          setTimeout(function() {
            _that.notification_msg = "";
            _that.notification_type = "";
          }, 5000);
        } catch (e) {}
      },
      setPercentage(val) {
        this.percentage = val;
        this.free_Margin = this.freeMargin * (val / 100)//this.floatingValue(this.freeMargin * (val / 100), this.send.currency);
      },
      priceForSelectedCurrency(from, to) {
        try {
          if (this.combinedCurrency.includes(from + "-" + to) && this.instruments[from + "-" + to]) {
            return this.instruments[from + "-" + to].A;
          } else if (this.combinedCurrency.includes(to + "-" + from) && this.instruments[to + "-" + from]) {
            return 1 / this.instruments[to + "-" + from].A;
          } else {
            return 0;
          }
        } catch (e) {
          return 0;
        }
        /*if (this.get_depth_all({ send: { currency: from }, recive: to }).B) {
                return this.get_depth_all({ send: { currency: from }, recive: to }).B;
              } else {
                return 0;
              }*/
      },
      get_depth_all(obj) {
        try {
          this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
          return this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].iCache.asKeysValueArray(obj);
        } catch (ex) {
          return {};
        }
      },
      getCurrency(value) {
        if (value.length > 0 && value[0].subAccounts.length > 0) {
          this._runGetMarginInfo({
            globalParams: {
              account_id: this.tradingAccount[0].account_id
            },
            localParams: {
              parameter: this,
              page: "exchange"
            },
          });
          if (value.length > 0 && this.orderList.records.length == 0) {
            let jsonData = {
              globalParams: {
                account_id: value[0].account_id,
                demo_live: value[0].demo_live,
              },
              localParams: {
                parameter: this
              },
            };
            this._runGetOrderList(jsonData);
          }
        }
      },
      downloadTransactions() {
        let headerCols = [],
          data = [],
          filename = "";
        filename = "exchange_transactions";
        headerCols = Object.keys(this.orderList.records[0]);
        data = this.orderList.records;
        this.csvExport(data, headerCols, filename);
      },
      csvExport(data, headers, filename) {
        let csvData = headers.join(", ").replace(/_/g, " ").toUpperCase();
        csvData += "\n";
        data.map((row) => {
          headers.map((i, index) => {
            if (index < headers.length - 1) {
              csvData += `${row[i]}, `;
            } else {
              csvData += `${row[i]}\n`;
            }
          });
        });
        var hiddenElement = document.createElement("a");
        hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvData);
        hiddenElement.target = "_blank";
        hiddenElement.download = filename;
        hiddenElement.click();
      },
    },
    created() {
      this.pageName("EXCHANGE");
      /*if (parseInt(this.accountSelected) == 1) {
              this.getCurrency(this.socialAccount, 0);
          } else {
              this.getCurrency(this.tradingAccount, 0);
          }*/
      this.getCurrency(this.tradingAccount);
      this._runCryptoList({
        globalParams: {},
        localParams: {
          parameter: this,
          page: "exchange"
        },
      });
      // this.getFirstMargin()
    },
    updated() {
      if (this.showSend) {
        document.getElementById("sendSearch").focus();
      } else if (this.showReceive) {
        document.getElementById("reciveSearch").focus();
      }
    },
    mounted() {
      const _that = this;
      $(document).on("click", function(event) {
        if (!$(event.target).closest(".showReceive").length) {
          _that.showReceive = false;
        }
        if (!$(event.target).closest(".showSend").length) {
          _that.showSend = false;
        }
      });
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/website/trading/smart_trading.vue